export const backendURL = "https://attbck.konekt.vip"